import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=147a8b9a&scoped=true"
import script from "./OrderPreview.vue?vue&type=script&lang=ts"
export * from "./OrderPreview.vue?vue&type=script&lang=ts"
import style0 from "./OrderPreview.vue?vue&type=style&index=0&id=147a8b9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a8b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147a8b9a')) {
      api.createRecord('147a8b9a', component.options)
    } else {
      api.reload('147a8b9a', component.options)
    }
    module.hot.accept("./OrderPreview.vue?vue&type=template&id=147a8b9a&scoped=true", function () {
      api.rerender('147a8b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/OrderPreview.vue"
export default component.exports